export default "<p>loader works!</p>\r\n"